module.exports = __webpack_public_path__ + "img/avatar.5a4c7f13.svg";